import { render, staticRenderFns } from "./joinMemberList.vue?vue&type=template&id=87bb176a&scoped=true&"
import script from "./joinMemberList.vue?vue&type=script&lang=js&"
export * from "./joinMemberList.vue?vue&type=script&lang=js&"
import style0 from "./joinMemberList.vue?vue&type=style&index=0&id=87bb176a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb176a",
  null
  
)

export default component.exports